import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useWatchlist, useWatchlists } from '@/hooks/useWatchlist';
import { doesCompanyExistInWatchlist } from '@/pages/Watchlist/utils';
import type { Components } from '@/reducers/page';

const useAddNoteAfterWatchingStock = ({
  companyId,
}: {
  companyId?: string;
}): boolean => {
  const { data: watchlist } = useWatchlist();
  const { data: watchlists } = useWatchlists();

  const hasMultipleWatchlists =
    typeof watchlists !== 'undefined' && watchlists.length > 1;

  const existsInSomeWatchlist = useMemo((): boolean => {
    if (typeof watchlist !== 'undefined' && typeof watchlists !== 'undefined') {
      const watchlistKeys = watchlist?.items.map((n) => n.companyId);
      const watchlistsKeys = watchlists?.flatMap((w) =>
        w.items.map((n) => n.companyId)
      );

      return doesCompanyExistInWatchlist(
        companyId,
        hasMultipleWatchlists ? watchlistsKeys : watchlistKeys
      );
    }
    return false;
  }, [companyId, hasMultipleWatchlists, watchlist, watchlists]);

  const current = useSelector<
    { page: { current: Components[keyof Components] } },
    Components[keyof Components]
  >((state) => {
    return state.page.current;
  }, shallowEqual);

  return (
    typeof companyId !== 'undefined' &&
    existsInSomeWatchlist &&
    current === 'CompanyReport'
  );
};

export default useAddNoteAfterWatchingStock;
